"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _DomEvents = require("../utils/DomEvents");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Functions = require("../core/Functions");

var _default = _react.default.createClass({
  displayName: "UIForm",
  propTypes: {
    action: _react.PropTypes.string,
    children: _react.PropTypes.node.isRequired,
    onSubmit: _react.PropTypes.func
  },
  handleKeyDown: function handleKeyDown(evt) {
    var _this$props = this.props,
        onKeyDown = _this$props.onKeyDown,
        onSubmit = _this$props.onSubmit;
    var key = evt.key;
    var inputFocused = document.activeElement instanceof HTMLInputElement;

    if (key === 'Enter') {
      if (evt.metaKey || evt.ctrlKey && !inputFocused) {
        (0, _Functions.callIfPossible)(onSubmit, (0, _SyntheticEvent.default)());
      }
    }

    (0, _Functions.callIfPossible)(onKeyDown, evt);
  },
  render: function render() {
    var _this$props2 = this.props,
        action = _this$props2.action,
        className = _this$props2.className,
        children = _this$props2.children,
        __onKeyDown = _this$props2.onKeyDown,
        onSubmit = _this$props2.onSubmit,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "className", "children", "onKeyDown", "onSubmit"]);
    return (
      /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
      _react.default.createElement("form", (0, _extends2.default)({}, rest, {
        className: (0, _classNames.default)('private-form', className),
        action: action,
        onKeyDown: this.handleKeyDown,
        onSubmit: !action && !onSubmit ? _DomEvents.preventDefaultHandler : onSubmit
      }), children)
      /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */

    );
  }
});

exports.default = _default;
module.exports = exports.default;